class gsapMayaaThemeExecution {
    constructor() {
        let e = document.querySelector("[data-header-type]"),
            t = document.querySelector("body"),
            o = document.querySelector(".announcement-bar-section");
        if (
            ((this.announcementBarHeight = 0),
            (this.headerHeight = 0),
            (this.rawHeaderHeight = 0),
            (this.rawHeaderSetting = "sticky"),
            (this.transparentHeader = "false"),
            (this.lastFocusedSectionTab = null),
            (this.viewportWidth = window.innerWidth),
            (this.viewportHeight = window.innerHeight),
            (this.scrollDirection = t.getAttribute("data-scroll-direction")),
            (this.isFireFoxBrowser = !1),
            navigator.userAgent.toLowerCase().includes("firefox") && (this.isFireFoxBrowser = !0),
            navigator.userAgent.includes("Safari") &&
                !navigator.userAgent.includes("Chrome") &&
                document.body.classList.add("safari-browser"),
            void 0 !== o && null != o && (this.announcementBarHeight = o.offsetHeight),
            void 0 !== e && null != e)
        ) {
            this.rawHeaderHeight = e.offsetHeight;
            let t = e.getAttribute("data-header-type");
            (this.transparentHeader = e.getAttribute("data-header-transparency")),
                (this.rawHeaderSetting = t),
                "sticky" == t
                    ? (this.headerHeight = e.offsetHeight + this.announcementBarHeight)
                    : "sticky-always" == t && (this.headerHeight = e.offsetHeight);
        }
        "undefined" != typeof gsap
            ? gsap.registerPlugin(ScrollTrigger, SplitText)
            : console.warn("GSAP is not defined");
    }
    headerWithLogoAnimation(e) {
        document.querySelector("header");
        const t = e.querySelector("[header-logo-link]").querySelectorAll("img"),
            o = t[0].getAttribute("width"),
            s = t[0].getAttribute("height"),
            i = e.getAttribute("data-logo-target-width") / o,
            a = s / 2,
            r = e.getAttribute("data-header-layout");
        let n = 0;
        ("header-hamburger" != r && "logo-center-menu-left" != r) || (n = -50);
        document.querySelector("body");
        gsap.set(t, { top: "100%", xPercent: n, scale: 1, yPercent: 0, y: 0, force3D: !0 });
        gsap.timeline({
            scrollTrigger: {
                id: "headerStickyAnimated",
                trigger: e,
                start: "top top",
                end: "150%",
                scrub: 1.5,
                invalidateOnRefresh: !0,
            },
        }).to(t, {
            ease: "power2.outIn",
            duration: 1,
            xPercent: n,
            scale: i,
            top: "50%",
            yPercent: 0,
            y: -a,
            force3D: !0,
        });
    }
    bannerSlider(e) {
        if (this.getBlockSizeMayaa(e) > 0) {
            let t = e.querySelectorAll("[hero-slider-slide-item-content]"),
                o = e.querySelector("[banner-slider-overlay-content]"),
                s = e.querySelector("[banner-slider-overlay]");
            const i = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            );
            let a = o.getBoundingClientRect().height,
                r = s.getBoundingClientRect().height / 2;
            a < r && (a = r);
            let n = e.getBoundingClientRect().height,
                l = e.querySelector("[banner-slider-marquee]"),
                c = null;
            gsap.set(s, { y: n }), gsap.set(s, { "--overlay-content-height": `${a}px` });
            let d = a / 2,
                g = (e.querySelectorAll("[marquee-text-banner-slider]"), e.querySelectorAll("[data-media-icons]"));
            gsap.timeline({
                ease: "none",
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (i ? 0 : this.headerHeight),
                    end: () => "+=100%",
                    pin: !0,
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                    onRefresh: () => {},
                },
            })
                .to(l, { xPercent: -15 })
                .to(t, { opacity: 0.1 }, "<")
                .to(
                    s,
                    {
                        y: () => -`${d}`,
                        onUpdate: function () {
                            const e = Math.round(100 * this.progress());
                            e !== c && ((c = e), gsap.set(s, { "--overlay-stop-value": `${e}%` }));
                        },
                    },
                    "<"
                );
            const p = e.querySelector("[banner-media-text-lines]");
            if (null != p) {
                let e = gsap.timeline({
                    scrollTrigger: { trigger: p, start: "top 130%", end: "bottom 100%", scrub: 1.5 },
                });
                const t = new SplitText(p, { type: "lines" });
                e.from(t.lines, { y: 50, opacity: 0, stagger: 0.05, duration: 0.5, ease: "none" }),
                    g.length > 0 &&
                        (gsap.set(g, { yPercent: (e) => (e % 2 == 0 ? -100 : 100), opacity: 0 }),
                        e.to(g, { yPercent: 0, opacity: 1 }));
            }
            this.focusTabSectionsCase(e);
        }
    }
    collectionCarousel(e) {
        if (this.getBlockSizeMayaa(e) > 1) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.querySelectorAll("[collection-carousel-item]"),
                s = o.length;
            let i = -1;
            const a = e.querySelectorAll("[collections-carousel-image-content]"),
                r = e.querySelector("[collection-carousel-heading-sec]");
            let n = 0;
            const l = e.querySelector("[collection-progress-bar-wrapper]");
            this.viewportWidth > l.offsetWidth && (n = (this.viewportWidth - l.offsetWidth) / 2);
            0 == parseInt(e.getAttribute("collection-slide-progress-bar")) && (n = 0);
            const c = e.querySelector("[collection-progress-line]"),
                d = e.getAttribute("collection-header-sticky");
            let g = e.querySelector("[collection-carousel-list]");
            "0" == d && (g = e.querySelector("[collection-carousel-wraper]"));
            const p = 50,
                u = e.scrollWidth - this.viewportWidth + n;
            a.length > 0 && gsap.set(a, { autoAlpha: 0, transformPerspective: 800 });
            const h = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: `+=${u + p}`,
                    pin: !0,
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                    onUpdate: (e) => {
                        const t = e.progress;
                        if ("1" == d) {
                            const o = r.querySelector(".section-header-wrapper").offsetWidth,
                                s = Math.abs(gsap.getProperty(g, "x"));
                            1 == e.direction
                                ? (s > o && r.classList.remove("carousel-content-visible"),
                                  t > 0.75 && r.classList.remove("carousel-content-visible"))
                                : (s < o && r.classList.add("carousel-content-visible"),
                                  1 == t && r.classList.remove("carousel-content-visible"),
                                  0 == t && r.classList.add("carousel-content-visible"));
                        }
                        const n = Math.min(s - 1, Math.floor(t * s));
                        n !== i &&
                            (o[n].classList.contains("active-item") ||
                                (o[n].classList.add("active-item"), a.length > 0 && y(n)),
                            (i = n));
                    },
                },
            });
            function y(e) {
                a[e].classList.add("active"), gsap.to(a[e], { autoAlpha: 1 });
                const t = a[e].querySelector("[collections-carousel-image-text]"),
                    o = a[e].querySelector("[collections-carousel-emoji-content]"),
                    s = gsap.timeline();
                null != t &&
                    (s.fromTo(
                        t,
                        { y: 0, rotationX: 0, rotationZ: 0, rotationY: 0 },
                        { y: -70, rotationX: 20, rotationZ: -10, rotationY: 15, ease: "Power2.easeOut", duration: 0.25 }
                    ),
                    s.to(t, { y: 0, rotationX: 0, rotationZ: 0, rotationY: 0, ease: "Bounce.easeOut", duration: 0.5 })),
                    null != o &&
                        (s.fromTo(
                            o,
                            { y: 0, rotationX: 0, rotationZ: 0, rotationY: 0 },
                            {
                                y: -70,
                                rotationX: 20,
                                rotationZ: -10,
                                rotationY: 15,
                                ease: "Power2.easeOut",
                                duration: 0.25,
                            }
                        ),
                        s.to(o, {
                            y: 0,
                            rotationX: 0,
                            rotationZ: 0,
                            rotationY: 0,
                            ease: "Bounce.easeOut",
                            duration: 0.5,
                        }));
            }
            h.to(g, { x: () => -u, ease: "none" }).to(c, { scaleX: 1 }, "<"), h.add(() => {}, "+=0.05");
        }
    }
    MediaCard(e) {
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelectorAll("[media-card-item]"),
            s = o[0].offsetHeight * o.length + (30 * o.length - 1);
        gsap.set(o, { y: (t) => (t > 0 ? e.offsetHeight + 30 * t : e.offsetHeight / 3) });
        const i = gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top top+=" + (t ? 0 : this.headerHeight),
                end: `+=${s}`,
                pin: !0,
                scrub: 1.5,
                invalidateOnRefresh: !0,
            },
        });
        o.forEach((e, t) => {
            i.to(e, { y: 30 * t });
        });
    }
    mediaWithTextSec(e) {
        if (this.getBlockSizeMayaa(e) > 1) {
            const t = e.querySelector("[left-side-media-overlay]"),
                o = e.querySelector("[right-side-media-overlay]"),
                s = e.getAttribute("data-animation-type");
            gsap.set([t, o], { xPercent: (e) => (0 === e ? 100 : -100) });
            const i = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top+=10% bottom",
                    end: "bottom center",
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                },
            });
            "square" == s
                ? i.to([t, o], { xPercent: (e) => (0 === e ? 0 : 0) }) 
                : i.to([t, o], { xPercent: (e) => (0 === e ? 0 : 0), rotateZ: (e) => (0 === e ? -3 : 3) });
        }
    }
    featuredBlogs(e) {
        const t = e.querySelector("[blogs-overlay-background]");
        gsap.set(t, { scaleX: 0.5, scaleY: 0.85 });
        gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top+=50% bottom",
                end: "bottom bottom-=15%",
                scrub: 1.5,
                invalidateOnRefresh: !0,
            },
        }).to(t, { scaleX: 1, scaleY: 1, borderRadius: 0 });
    }
    bestSellingProducts(e) {
        if (this.getBlockSizeMayaa(e) > 0) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.querySelector("[product-right-content-area]"),
                s = e.querySelectorAll("[product-right-title]"),
                i = e.querySelectorAll("[product-right-title-inner]"),
                a = e.querySelectorAll("[product-main-content-area]"),
                r = e.querySelector("[product-list-media]"),
                n = e.querySelector("[product-content-left-area]"),
                l = window.getComputedStyle(n, null).getPropertyValue("column-gap"),
                c = e.querySelector("count-down");
            let d = null,
                g = null,
                p = !1,
                u = e.offsetHeight;
            this.getBlockSizeMayaa(e) > 2 && (u *= 1.5),
                gsap.set([s, a], { opacity: 0 }),
                gsap.set(i, { xPercent: -50, yPercent: -50, left: "50%" }),
                gsap.set(s, {
                    width: "50%",
                    height: "50%",
                    y: (e) => -125 * e + 1 - 25,
                    x: r.offsetWidth + parseInt(l),
                    rotation: "38",
                    fontSize: 30,
                    opacity: 0,
                    zIndex: (e) => {
                        s.length;
                    },
                });
            const h = gsap.timeline({
                ease: "none",
                force3d: !0,
                duration: 0.2,
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: `+=${u}`,
                    pin: !0,
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                    onUpdate: (t) => {
                        if (t.direction !== d) {
                            d = t.direction;
                            const o = 1 === d ? "down" : "up";
                            e.setAttribute("data-scroll-direction", o);
                        }
                    },
                },
            });
            if (
                (h
                    .to(s, {
                        y: (e) => -125 * e + 1 - 25,
                        opacity: 0.9,
                        rotation: "35",
                        onStart: function () {
                            o.classList.remove("show-element");
                        },
                    })
                    .to(s, {
                        y: (e) => -125 * (e + 1) - 25 - 15 * e,
                        marginTop: "50%",
                        rotation: 0,
                        opacity: 1,
                        width: "100%",
                        height: "100%",
                        x: 0,
                        onStart: function () {
                            gsap.set(a, { opacity: 0 });
                        },
                        onComplete: function () {
                            o.classList.add("show-element");
                        },
                        onUpdate: function () {
                            const t = e.getAttribute("data-scroll-direction");
                            t !== g &&
                                ((g = t),
                                "up" === t &&
                                    o.classList.contains("show-element") &&
                                    o.classList.remove("show-element"));
                        },
                    })
                    .to(s, { y: -25, marginTop: "0%" })
                    .to(s, {
                        width: "70%",
                        height: "25%",
                        y: 0,
                        x: r.offsetWidth + parseInt(l),
                        fontSize: "inherit",
                        onStart: function () {
                            gsap.set(a, { opacity: 1 });
                        },
                        onReverseComplete: function () {
                            gsap.set(a, { opacity: 0 });
                        },
                        onUpdate: function () {
                            const e = 100 * this.progress();
                            e > 75 && !p
                                ? ((p = !0),
                                  o.classList.add("animation-completed"),
                                  i.forEach((e, t) => {
                                      const o = e.getBoundingClientRect().height;
                                      gsap.set(a[t], { "--best-selling-product-title-height": `${o}px` });
                                  }))
                                : e <= 75 && p && ((p = !1), o.classList.remove("animation-completed"));
                        },
                    })
                    .to(i, { xPercent: 0, left: "0%" }, "<"),
                h.add(() => {}, "+=0.05"),
                void 0 !== c && null != c)
            ) {
                e.querySelectorAll(".best-selling-counter-inner").forEach((e, t) => {
                    e.addEventListener("mousemove", (t) => {
                        const o = e.getBoundingClientRect(),
                            s = o.width,
                            i = o.height,
                            a = t.clientX - o.left - s / 2,
                            r = t.clientY - o.top - i / 2,
                            n = (r / (i / 2)) * 12,
                            l = (a / (s / 2)) * -12,
                            c = (Math.sqrt(a ** 2 + r ** 2) / Math.sqrt((s / 2) ** 2 + (i / 2) ** 2)) * 8;
                        gsap.to(e, { duration: 0.5, rotationY: n, rotationX: l, rotationZ: c, ease: "power2.out" });
                    }),
                        e.addEventListener("mouseleave", () => {
                            gsap.to(e, { rotationY: 0, rotationX: 0, rotationZ: 0, ease: "power2.out" });
                        });
                });
            }
            this.focusTabSectionsCase(e);
        }
    }
    productsGrid(e) {
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = parseInt(e.getAttribute("data-collection-count")),
            s = e.querySelectorAll("[products-grid-item]"),
            i = e.querySelectorAll("[products-grid-item]"),
            a = e.querySelectorAll("[products-grid-items]"),
            r = e.querySelector("[products-grid-header]"),
            n = e.querySelector("[product-grid-overlay-heading]"),
            l = e.closest("[product-grid-section-wrapper]"),
            c = e.querySelectorAll("[grid-item-three-item]"),
            d = e.querySelectorAll("[grid-item-two-item]"),
            g = e.querySelector("[product-grid-body]"),
            p = e.querySelectorAll("[product-grid-collection-item]"),
            u = e.getAttribute("data-line-animation"),
            h = e.closest("section").querySelector("[moving-lines-animation]"),
            y = s[0].offsetHeight / 2,
            m = Math.min(3.5 * window.innerHeight, 1500);
        let f = !1,
            b = 0;
        null != r && (b = gsap.getProperty(r.querySelector(".section-header"), "marginBottom"));
        let v = parseInt(c[0].offsetHeight) - parseInt(l.offsetHeight);
        const S = 2 * window.innerHeight;
        (v = v / 1.25 + y),
            gsap.set(l, { paddingBottom: v }),
            gsap.set(s, { zIndex: (e, t, o) => (5 == e || 6 == e ? 2 * o.length + e : 2 * o.length - e), opacity: 0 }),
            "true" == u && null != h && gsap.set(h, { "--line-stroke-dashoffset-start": S });
        const w = g.offsetHeight / 3,
            x = w - b,
            A = w / 2 + b,
            q = i[0].offsetHeight / 2,
            L = i[0].offsetWidth,
            T = i[0].offsetHeight,
            C = [x + q, x - q, -(A + q)],
            P = [x, -A, -(A + T)];
        p.forEach((e, t) => {
            gsap.set(e, { y: window.innerHeight });
        });
        for (let e = 0; e < a.length; e++)
            if (e % 2 == 0) {
                let t = 2 * L;
                2 == e && (t = 0),
                    a[e].querySelectorAll("[products-grid-item]").forEach((o, s) => {
                        gsap.set(o, { x: e > 0 ? -t : t, y: s > 0 ? -A : x });
                    });
            } else
                a[e].querySelectorAll("[products-grid-item]").forEach((t, o) => {
                    gsap.set(t, { x: 1 == e ? L : -L, y: C[o] });
                });
        const M = gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top top+=" + (t ? 0 : this.headerHeight),
                end: `+=${m}`,
                scrub: 1.5,
                pin: !0,
                invalidateOnRefresh: !0,
                onUpdate: (t) => {
                    const o = t.progress > 0.95;
                    o && !f
                        ? ((f = !0), e.classList.add("product-grid-animation-completed"))
                        : !o && f && ((f = !1), e.classList.remove("product-grid-animation-completed"));
                },
                onEnter: () => {
                    "true" == u &&
                        null != h &&
                        gsap.to(h, { "--line-stroke-dashoffset-end": 0, duration: 2.5, ease: "sine.inOut" });
                },
            },
        });
        1 == o
            ? M.to(p[0], {
                  y: P[0],
                  onReverseComplete: () => {
                      "true" == u &&
                          null != h &&
                          gsap.to(h, { "--line-stroke-dashoffset-end": S, duration: 2.5, ease: "sine.inOut" });
                  },
                  onComplete: () => {
                      gsap.to(p, { opacity: 0, duration: 0.5 }), gsap.to(s, { opacity: 1, duration: 0.5 });
                  },
              })
            : 2 == o
              ? M.to(p[0], {
                    y: P[0],
                    onReverseComplete: () => {
                        "true" == u &&
                            null != h &&
                            gsap.to(h, { "--line-stroke-dashoffset-end": S, duration: 2.5, ease: "sine.outIn" });
                    },
                }).to(p[1], {
                    y: P[1],
                    onComplete: () => {
                        gsap.to(p, { opacity: 0, duration: 0.5 }), gsap.to(s, { opacity: 1, duration: 0.5 });
                    },
                })
              : 3 == o &&
                M.to(p[0], {
                    y: P[0],
                    onReverseComplete: () => {
                        "true" == u &&
                            null != h &&
                            gsap.to(h, { "--line-stroke-dashoffset-end": S, duration: 2.5, ease: "sine.inOut" });
                    },
                })
                    .to(p[1], { y: P[1] })
                    .to(p[2], {
                        y: P[2],
                        onComplete: () => {
                            gsap.to(p, { opacity: 0, duration: 0.5 }), gsap.to(s, { opacity: 1, duration: 0.5 });
                        },
                    }),
            M.to(s, {
                x: 0,
                y: 0,
                scale: 0.95,
                ease: "sine.inOut",
                onReverseComplete: () => {
                    gsap.to(s, { opacity: 0, duration: 0.5 }), gsap.to(p, { opacity: 1, duration: 0.5 });
                },
            })
                .to(d, { top: y / 2 }, "<")
                .to(c, { marginTop: y + b }, "<")
                .to(r, { opacity: 0 }, "<")
                .to(n, { opacity: 0, autoAlpha: 0 }, "<"),
            M.add(() => {}, "+=0.10"),
            this.focusTabSectionsCase(e);
    }
    videoWithTextOverlay(e) {
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelector("[video-text-overlay-media]"),
            s = e.querySelector("[video-text-content-inner]"),
            i = gsap.getProperty(o, "--overlay-media-size"),
            a = e.querySelector("[video-with-text-marquee]"),
            r = e.querySelector("[video-text-radius-media]"),
            n = gsap.getProperty(r, "--card-radius"),
            l = e.offsetHeight / 1.5,
            c = e.getAttribute("data-animation-type");
        let d = !1;
        gsap.set(o, { rotation: 0 }), gsap.set(r, { borderRadius: 0 }), null != a && gsap.set(a, { yPercent: 100 });
        let g = 0;
        "tilt" == c && (g = -4);
        const p = gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top top+=" + (t ? 0 : this.headerHeight),
                end: `+=${l}`,
                pin: !0,
                scrub: 1.5,
                invalidateOnRefresh: !0,
            },
        });
        p
            .to(o, {
                rotation: g,
                scale: i,
                onUpdate: function () {
                    const e = this.progress() >= 0.5;
                    e && !d
                        ? ((d = !0),
                          o.classList.add("overlay-media-scrolled"),
                          null != s && s.classList.add("scroll-content-active"))
                        : !e &&
                          d &&
                          ((d = !1),
                          o.classList.remove("overlay-media-scrolled"),
                          null != s && s.classList.remove("scroll-content-active"));
                },
            })
            .to(r, { borderRadius: n }, "<"),
            null != a && p.to(a, { yPercent: 0 }, "<"),
            this.focusTabSectionsCase(e);
    }
    scrollableCollection(e) {
        if (this.getBlockSizeMayaa(e) > 0) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.getAttribute("data-animation-style"),
                s = e.querySelector("[scrollable-product-above-background]"),
                i = e.querySelector("[scrollable-first-product]"),
                a = e.querySelectorAll("[scrollable-collection-items]"),
                r = e.getAttribute("data-counter-enable"),
                n = e.querySelector("[scrollable-product-overlay-contentwrap]"),
                l = e.querySelector("[scrollabe-header-layout-wrapper]"),
                c = e.querySelector("[scrollable-header-content]"),
                d = e.querySelector("[scrollable-collection-content]"),
                g = a.length > 1 ? this.viewportHeight * (a.length - 1) : this.viewportHeight;
            let p = 0,
                u = 0,
                h = [0, 0];
            const y = e.querySelector("[scrollabe-counter-active-slide]"),
                m = e.querySelector("[scrollabe-counter-box]");
            if ("on" == r) {
                (p = gsap.getProperty(m, "--counter-box-radius")),
                    (e.querySelector("[scrollabe-counter-total-slide]").innerText = "0" + a.length),
                    (u = gsap.getProperty(m, "--counter-box-size"));
                h = [Math.min(u / this.viewportWidth), Math.min(u / this.viewportHeight)];
            }
            const f = a.length + 1;
            "media-with-overlay" == o ? gsap.set(i, { opacity: 1 }) : gsap.set([d, a[0]], { opacity: 0 });
            let b = !1,
                v = -1,
                S = "";
            const w = gsap.timeline({
                ease: "none",
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: `+=${g}`,
                    scrub: !0,
                    pin: !0,
                    invalidateOnRefresh: !0,
                    onUpdate: (e) => {
                        b ||
                            ((b = !0),
                            requestAnimationFrame(() => {
                                x(e), (b = !1);
                            }));
                    },
                },
            });
            function x(e) {
                if ("on" !== r) return;
                const t = e.progress,
                    s = e.direction,
                    n = "media-with-overlay" === o ? Math.floor(t * f) : Math.floor(t * a.length),
                    l = 1 === s;
                function c(e) {
                    e !== S && ((y.innerText = e), (S = e));
                }
                if ((n !== v && (v = n), "media-with-overlay" === o))
                    if (l) {
                        if (n > 1 && n <= a.length) {
                            const e = +gsap.getProperty(a[n - 1], "--scrollable-media-clip").toFixed(2);
                            e > 49 && e < 55 && c(a[n - 1].getAttribute("scrollable-item-count"));
                        }
                        if (1 === n) {
                            const e = w.getChildren()[1].progress();
                            e > 0.75
                                ? (gsap.set(i, { opacity: Math.max(0, 1 - (e - 0.75) / 0.25) }),
                                  gsap.set(m, { "--counter-box-opacity": Math.min(1, (e - 0.75) / 0.25) }))
                                : (gsap.set(m, { "--counter-box-opacity": 0 }), gsap.set(i, { opacity: 1 }));
                        }
                        1 === t &&
                            (gsap.set(i, { opacity: 0 }),
                            gsap.set(m, { "--counter-box-opacity": 1 }),
                            c("0" + (n - 1)));
                    } else {
                        if (n > 1) {
                            +gsap.getProperty(a[n - 1], "--scrollable-media-clip").toFixed(2) > 50 && c("0" + (n - 1));
                        }
                        if (1 === n) {
                            const e = w.getChildren()[1].progress();
                            e >= 0.75 && e <= 1
                                ? (gsap.set(i, { opacity: Math.min(1, (1 - e) / 0.25) }),
                                  gsap.set(m, { "--counter-box-opacity": Math.max(0, (e - 0.75) / 0.25) }))
                                : (gsap.set(i, { opacity: 1 }), gsap.set(m, { "--counter-box-opacity": 0 }));
                        }
                        1 === t &&
                            (gsap.set(i, { opacity: 0 }),
                            gsap.set(m, { "--counter-box-opacity": 1 }),
                            c("0" + (n - 1)));
                    }
                else if (l) {
                    if (0 === n) {
                        const e = w.getChildren()[0].progress();
                        gsap.set(m, { "--counter-box-opacity": e > 0.7 ? 1 : 0 });
                    }
                    if (n > 0 && n < a.length) {
                        const e = +gsap.getProperty(a[n], "--scrollable-media-clip").toFixed(2);
                        e > 49 && e < 55 && c(a[n].getAttribute("scrollable-item-count"));
                    }
                    1 === t && (gsap.set(m, { "--counter-box-opacity": 1 }), c(`0${n}`));
                } else {
                    if ((0 === n && gsap.set(m, { "--counter-box-opacity": 0 }), n > 0)) {
                        +gsap.getProperty(a[n], "--scrollable-media-clip").toFixed(2) > 50 && c(`0${n}`);
                    }
                    1 === t && (gsap.set(m, { "--counter-box-opacity": 1 }), c(`0${n}`));
                }
            }
            "media-with-overlay" == o
                ? (w.to([s, n], { yPercent: -100, rotate: -14 }).fromTo(
                      i,
                      { scaleX: 1, scaleY: 1 },
                      {
                          scaleX: h[0],
                          scaleY: h[1],
                          borderRadius: 5 * p + p / 2,
                          onComplete: () => {
                              "on" == r && (gsap.set(i, { opacity: 0 }), gsap.set(m, { "--counter-box-opacity": 1 }));
                          },
                      }
                  ),
                  w.fromTo(
                      a[0],
                      { "--scrollable-media-clip": "0%", "--scrollable-media-zoom": 1.2, zIndex: 0 },
                      {
                          "--scrollable-media-clip": "0%",
                          "--scrollable-media-zoom": 1,
                          onStart() {
                              gsap.to(this.targets()[0], { zIndex: 1 });
                          },
                      },
                      "<"
                  ))
                : (w.to(l, { opacity: 0 }).to(c, { scale: 0.8, opacity: 0 }, "<"),
                  w.fromTo(d, { opacity: 0 }, { opacity: 1 }, "<").fromTo(
                      a[0],
                      { "--scrollable-media-clip": "0%", "--scrollable-media-zoom": 1.2, opacity: 0, zIndex: 0 },
                      {
                          "--scrollable-media-clip": "0%",
                          "--scrollable-media-zoom": 1,
                          opacity: 1,
                          onStart() {
                              gsap.to(this.targets()[0], { zIndex: 1 }), l.classList.add("scrollable-text-fade-out");
                          },
                          onReverseComplete() {
                              l.classList.remove("scrollable-text-fade-out");
                          },
                      },
                      "<"
                  )),
                a.length > 1 &&
                    a.forEach((e, t) => {
                        t > 0 &&
                            w.fromTo(
                                e,
                                { "--scrollable-media-clip": "100%", "--scrollable-media-zoom": 1.2, zIndex: 0 },
                                {
                                    "--scrollable-media-clip": "0%",
                                    "--scrollable-media-zoom": 1,
                                    onStart() {
                                        gsap.to(this.targets()[0], { zIndex: t + 1 });
                                    },
                                }
                            );
                    }),
                this.focusTabSectionsCase(e);
        }
    }
    featuredProductSecondaryView(e) {
        if ("V2" == e.getAttribute("variantFeatureVersion")) {
            if ("none" == this.getSectionAnimationStyle(e)) return !1;
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = (e.querySelector("[feature-product-header]"), e.querySelectorAll("[feature-product-left-part]")),
                s = e.querySelectorAll("[feature-product-right-part]"),
                i = e.querySelector("[feature-product-thumb-main]"),
                a = e.querySelectorAll("[thumb-feature-product-item]"),
                r = e.querySelector("[feature-product-main-wrapper]");
            null != o && gsap.set(o, { xPercent: -125 }),
                null != s && gsap.set(s, { xPercent: 125 }),
                null != i && gsap.set([i, a], { scale: 0 });
            gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e,
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: "+=100%",
                    scrub: !0,
                    pin: !0,
                    invalidateOnRefresh: !0,
                    onEnter: () => {
                        gsap.to(r, { yPercent: -100, duration: 0.8, ease: "power4.inOut" }),
                            null != o
                                ? null != o && null != s
                                    ? this.isFireFoxBrowser
                                        ? gsap.to([o, s], { xPercent: 0, duration: 0.8, ease: "power2.outIn" })
                                        : gsap.to([o, s], {
                                              xPercent: 0,
                                              duration: 0.8,
                                              stagger: { amount: 0.2, from: "start", ease: "power2.outIn" },
                                          })
                                    : this.isFireFoxBrowser
                                      ? gsap.to(o, { xPercent: 0, duration: 0.8 })
                                      : gsap.to(o, {
                                            xPercent: 0,
                                            duration: 0.8,
                                            ease: "power2.outIn",
                                            stagger: { amount: 0.2, from: "start", ease: "power2.outIn" },
                                        })
                                : null != s &&
                                  (this.isFireFoxBrowser
                                      ? gsap.to(s, { xPercent: 0, duration: 0.8 })
                                      : gsap.to(s, {
                                            xPercent: 0,
                                            duration: 0.8,
                                            stagger: { amount: 0.2, from: "start", ease: "power2.outIn" },
                                        })),
                            null != i && gsap.to([i, a], { scale: 1.01, ease: "power4.inOut" });
                    },
                    onLeaveBack: () => {
                        "up" == document.body.getAttribute("data-scroll-direction") &&
                            (null != o
                                ? null != o && null != s
                                    ? this.isFireFoxBrowser
                                        ? (gsap.to(o, { xPercent: -125, duration: 0.8 }),
                                          gsap.to(s, { xPercent: 125, duration: 0.8 }))
                                        : (gsap.to(o, {
                                              xPercent: -125,
                                              duration: 0.8,
                                              stagger: { amount: 0.2, from: "start", ease: "power2.inOut" },
                                          }),
                                          gsap.to(s, {
                                              xPercent: 125,
                                              duration: 0.8,
                                              stagger: { amount: 0.2, from: "start", ease: "power2.inOut" },
                                          }))
                                    : this.isFireFoxBrowser
                                      ? gsap.to(o, { xPercent: -125, duration: 0.8 })
                                      : gsap.to(o, {
                                            xPercent: -125,
                                            duration: 0.8,
                                            stagger: { amount: 0.2, from: "start", ease: "power2.inOut" },
                                        })
                                : null != s &&
                                  (this.isFireFoxBrowser
                                      ? gsap.to(s, { xPercent: 125, duration: 0.8 })
                                      : gsap.to(s, {
                                            xPercent: 125,
                                            duration: 0.8,
                                            stagger: { amount: 0.2, from: "start", ease: "power2.inOut" },
                                        })),
                            null != i && gsap.to([i, a], { scale: 0 }),
                            gsap.to(r, { yPercent: 0, duration: 0.8, ease: "power4.inOut" }));
                    },
                },
            });
            this.focusTabSectionsCase(e);
        }
    }
    verticalCarousel(e) {
        if (this.getBlockSizeMayaa(e) < 3) return !1;
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelector("[vertical-circle-rotate]"),
            s = e.querySelectorAll("[vertical-circle-item]"),
            i = e.querySelectorAll("[vertical-circle-content]"),
            a = e.querySelectorAll("[vc-inner-content]"),
            r = e.querySelector("[verticle-circle-header]"),
            n = e.getAttribute("data-animation-type"),
            l = e.querySelector("[vertical-right-section-main]");
        gsap.set(l, { "--slide-card-width": `${l.offsetWidth}px` });
        const c = s.length,
            d = s[0].getBoundingClientRect().width,
            g = gsap.getProperty(s[0], "borderRadius");
        let p = (((u = d) * (h = c) + (h > 4 ? u / 2 : u)) / (2 * Math.PI)) * 2;
        var u, h;
        const y = (2 * Math.PI) / c,
            m = y * (180 / Math.PI);
        p = p.toFixed(2);
        let f = p / 2;
        f = f.toFixed(2);
        const b = 360 - m,
            v = -m,
            S = [],
            w = [];
        for (let e = 0; e < s.length; e++) {
            let t = v + m * e;
            e > 0 && (S.push(Math.round(t - 10)), w.push(Math.round(t + 10)));
        }
        S.push(Math.round(b)), w.push(Math.round(b));
        let x = 90;
        const A = x / 2;
        g > 0 && ((x = g > x ? g - x : x - g), x < A && (x = A)),
            c > 4 && ((x = 150), g > 0 && (x -= g)),
            (f = parseInt(f) + x),
            gsap.set(s, { opacity: 0 }),
            gsap.set(s[0], { opacity: 1 }),
            gsap.set(o, { width: p, height: p, rotateZ: null != r ? -m : 0 }),
            null == r && (i[0].classList.add("active"), a[0].classList.add(n));
        s.forEach((e, t) => {
            let o = y * t;
            o *= -1;
            const s = (180 - t * m) * (Math.PI / 180);
            const i = f * Math.cos(s),
                a = f * Math.sin(s);
            gsap.set(e, { xPercent: -50, yPercent: -50, x: i, y: a, rotation: `${o}_rad` });
        });
        const q = gsap.timeline({
            ease: "none",
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top top+=" + (t ? 0 : this.headerHeight),
                end: "+=" + 2 * p,
                pin: !0,
                scrub: !0,
                invalidateOnRefresh: !0,
                onUpdate: (e) => {
                    const t = gsap.getProperty(o, "rotateZ");
                    if (1 === e.direction) {
                        const e = (function (e, t) {
                            for (let o = 0; o < t.length - 1; o++) if (e >= t[o] && e < t[o + 1]) return o;
                            if (e === t[t.length - 1]) return t.length - 1;
                            return null;
                        })(t, S);
                        if (null !== e && e >= 0) {
                            if (
                                (null !== r &&
                                    (r.classList.remove("active"),
                                    r.querySelector(".vertical-carousel-header-inner").classList.remove(n)),
                                o.classList.add("border"),
                                !i[e].classList.contains("active"))
                            ) {
                                const t = i[e].querySelectorAll("[thumb-product-wrapper]");
                                if (null != t && t.length > 0) {
                                    i[e].querySelectorAll("[thumb-product-content]");
                                    t[0].classList.add("active");
                                }
                                L(i, "active"), L(a, n), i[e].classList.add("active"), a[e].classList.add(n);
                            }
                            s[e].classList.contains("active") ||
                                (T(s), gsap.set(s[e], { opacity: 1 }), s[e].classList.add("active")),
                                e < s.length - 1 && gsap.set(s[e + 1], { opacity: 1 }),
                                e == s.length - 1 && gsap.set(s[0], { opacity: 0 });
                        } else
                            L(i, "active"),
                                L(a, n),
                                T(s),
                                null !== r &&
                                    (r.classList.add("active"),
                                    r.querySelector(".vertical-carousel-header-inner").classList.add(n)),
                                o.classList.remove("border");
                    } else {
                        const e = (function (e, t, o) {
                            if (e > -o / 2)
                                for (let o = t.length - 1; o >= 0; o--)
                                    if (e <= t[o] && e > (t[o - 1] || -1 / 0)) return o;
                            return null;
                        })(t, w, m);
                        if (null !== e && e >= 0) {
                            if (
                                (null !== r &&
                                    (r.classList.remove("active"),
                                    r.querySelector(".vertical-carousel-header-inner").classList.remove(n)),
                                o.classList.add("border"),
                                !i[e].classList.contains("active"))
                            ) {
                                const t = i[e].querySelectorAll("[thumb-product-wrapper]");
                                if (null != t && t.length > 0) {
                                    i[e].querySelectorAll("[thumb-product-content]");
                                    t[0].classList.add("active");
                                }
                                L(i, "active"), L(a, n), i[e].classList.add("active"), a[e].classList.add(n);
                            }
                            s[e].classList.contains("active") ||
                                (T(s), gsap.set(s[e], { opacity: 1 }), s[e].classList.add("active")),
                                e < s.length && e > 0 && gsap.set(s[e - 1], { opacity: 1 }),
                                0 == e &&
                                    (gsap.set(s, { opacity: 0 }),
                                    gsap.set(s[e], { opacity: 1 }),
                                    gsap.set(s[e + 1], { opacity: 1 }));
                        } else
                            L(i, "active"),
                                L(a, n),
                                T(s),
                                null !== r &&
                                    (r.classList.add("active"),
                                    r.querySelector(".vertical-carousel-header-inner").classList.add(n)),
                                o.classList.remove("border");
                    }
                },
            },
        });
        function L(e, t) {
            e.forEach((e, o) => {
                e.classList.remove(t);
            });
        }
        function T(e) {
            e.forEach((e, t) => {
                e.classList.remove("active");
            });
        }
        q.to(o, { rotateZ: b, ease: "none", duration: 1 }), q.add(() => {}, "+=0.08"), this.focusTabSectionsCase(e);
    }
    featuredCollectionStacked(e) {
        let t = !1;
        const o = e.getAttribute("animation-type");
        "once" == o && (t = !0);
        const s = e.querySelectorAll("[data-collection-product-item]");
        let i = e.querySelector("[data-column-count]").getAttribute("data-column-count");
        gsap.set(e, { "--fetaureItemCount": s.length }), (i -= 1);
        let a = 0;
        ScrollTrigger.batch(s, {
            once: t,
            invalidateOnRefresh: !0,
            onEnter: (e) => {
                e.forEach((e) => {
                    "repeat" === o && e.classList.remove("slide-out-top", "slide-in-top"),
                        e.classList.add("slide-in-bottom");
                });
            },
            onLeave: (e) => {
                e.forEach((e) => {
                    "repeat" === o &&
                        (e.classList.remove("slide-in-bottom", "slide-in-top"), e.classList.add("slide-out-top"));
                });
            },
            onEnterBack: (e) => {
                e.forEach((e) => {
                    "repeat" === o &&
                        (e.classList.remove("slide-in-bottom", "slide-out-top"), e.classList.add("slide-in-top"));
                });
            },
            onLeaveBack: (e) => {
                e.forEach((e) => {
                    "repeat" === o && e.classList.remove("slide-out-top", "slide-in-top", "slide-in-bottom");
                });
            },
        }),
            s.forEach((e, t) => {
                gsap.set(e, { "--indexFeatureItem": a }), a++, a > parseInt(i) && (a = 0);
            });
    }
    scrollableMarquee(e) {
        if ("marquee" == e.getAttribute("data-animation-type")) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.getAttribute("data-animation-image-style"),
                s = e.querySelector("[scrollable-marquee-scale]"),
                i =
                    (e.querySelector("[scrollable-marquee-inner]"),
                    e.querySelectorAll("[scrollable-marquee-even-row]")),
                a = i[0].getAttribute("data-direction"),
                r = e.querySelectorAll("[scrollable-marquee-odd-row]"),
                n = r[0].getAttribute("data-direction"),
                l = Math.min(2 * window.innerHeight, 1500);
            let c = !1,
                d = "circle(0% at 50% 50%)",
                g = "circle(100% at 50% 50%)";
            null != s && ("square" == o && ((d = "inset(100%)"), (g = "inset(0%)")), gsap.set(s, { clipPath: `${d}` }));
            const p = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: `+=${l}`,
                    pin: !0,
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                },
            });
            if (
                (p.to(r, { xPercent: "ltr" == n ? 15 : -15 }).to(i, { xPercent: "ltr" == a ? 15 : -15 }, "<"),
                null != s)
            ) {
                let t = 65;
                "square" == o && (t = 80),
                    p.to(s, {
                        clipPath: `${g}`,
                        onUpdate: function () {
                            const o = Math.round(100 * this.progress()) > t;
                            o && !c
                                ? ((c = !0), e.classList.add("media-visible"))
                                : !o && c && ((c = !1), e.classList.remove("media-visible"));
                        },
                    });
            }
            this.focusTabSectionsCase(e);
        }
    }
    richText(e) {
        if (this.getBlockSizeMayaa(e) > 0) {
            if ("none" == this.getSectionAnimationStyle(e)) return !1;
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.querySelector("[rich-text-wrapper]"),
                s = e.getAttribute("data-animation-type"),
                i = e.querySelector("[rich-animated-color]"),
                a = e.querySelectorAll("[rich-text-collection-item]"),
                r = e.querySelector("[rich-text-collection-item-center]"),
                n = e.querySelectorAll("[rich-text-collection-item]:not([rich-text-collection-item-center])");
            let l = !1,
                c = !1;
            const d = [];
            let g = [];
            if ("color-based" == s && (gsap.set(i, { scale: 15 }), (l = !0), a.length > 0)) {
                let e = 0,
                    t = 0;
                const o = r.getBoundingClientRect();
                a.forEach((s, i) => {
                    if (!s.hasAttribute("rich-text-collection-item-center") && s.getBoundingClientRect().x > o.x) {
                        const i = s.getBoundingClientRect().x - o.x,
                            a = gsap.getProperty(s, "marginLeft"),
                            r = gsap.getProperty(s, "border-width"),
                            n = Math.abs(a);
                        (e += n), (t += parseInt(r)), d.push(-(i - e));
                    }
                });
                const s = [...d].reverse().map(Math.abs);
                (g = [...s, ...d]), gsap.to(n, { x: (e) => g[e] });
            }
            const p = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "color-based" == s ? "top top+=" + (t ? 0 : this.headerHeight) : "top 25%",
                    end: "+=125%",
                    scrub: 1.5,
                    pin: l,
                    invalidateOnRefresh: !0,
                    onEnter: () => {
                        o.classList.add("in-visible-state");
                    },
                    onLeave: () => {
                        o.classList.remove("in-visible-state");
                    },
                    onEnterBack: () => {
                        o.classList.add("in-visible-state");
                    },
                    onLeaveBack: () => {
                        o.classList.remove("in-visible-state");
                    },
                    onUpdate: (e) => {
                        if ("color-based" == s && a.length > 0) {
                            const t = Math.round(100 * e.progress);
                            -1 === e.direction &&
                                t < 85 &&
                                !c &&
                                ((c = !0), gsap.to(n, { x: (e) => g[e], duration: 0.5, ease: "power1.outIn" })),
                                1 === e.direction && t >= 85 && (c = !1);
                        }
                    },
                },
            });
            "color-based" == s &&
                (p
                    .to(i, {
                        scale: a.length > 0 ? 1 : 0,
                        onComplete: () => {
                            a.length > 0 && gsap.to(n, { x: 0, duration: 0.5, ease: "power1.inOut" });
                        },
                    })
                    .fromTo(e, { "--text-reveal-percentage": "100%" }, { "--text-reveal-percentage": "0%" }, "<"),
                a.length > 0 && p.to(i, {})),
                this.focusTabSectionsCase(e);
        }
    }
    scrollableCollectionList(e) {
        const t = e.getAttribute("data-animation-style"),
            o = e.querySelectorAll("[collection-name-text]"),
            s = e.querySelectorAll(".collection-text-media");
        if ("v2" == t) {
            e.querySelectorAll("[collection-name-text-inner]");
            const t = Math.min(window.innerHeight, 1e3),
                i = o.length - 1;
            gsap.set(o, { yPercent: 100 }),
                gsap.set(o[0], { yPercent: 0 }),
                gsap.set(s, { scale: 0.7, opacity: 0 }),
                gsap.set(s[0], { scale: 1, opacity: 1 });
            const a = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + this.headerHeight,
                    end: "+=" + t * i,
                    scrub: 1.5,
                    pin: !0,
                    invalidateOnRefresh: !0,
                    onEnter: () => {
                        o[0].classList.add("active");
                    },
                    onLeave: () => {
                        o[0].classList.remove("active");
                    },
                    onLeaveBack: () => {
                        o[0].classList.remove("active");
                    },
                },
            });
            o.forEach((e, t) => {
                t > 0 &&
                    a
                        .to(e, {
                            yPercent: 0,
                            onUpdate: function () {
                                let s = this.progress();
                                s > 0.5 ? e.classList.add("active") : e.classList.remove("active"),
                                    1 == t && s < 0.4 && o[0].classList.add("active");
                            },
                        })
                        .to(s[t], { scale: 1, opacity: 1 }, "<")
                        .to(
                            o[t - 1],
                            {
                                yPercent: -100,
                                onComplete: () => {
                                    o[t - 1].classList.remove("active");
                                },
                            },
                            "<"
                        )
                        .to(s[t - 1], { scale: 0.7, opacity: 0 }, "<");
            });
        } else {
            gsap.set(o, { rotateX: -120 });
            const t = gsap.timeline({});
            let s = "top 80%";
            o.forEach((i, a) => {
                a > 0 && (s = "top 50%"),
                    t.to(i, {
                        ease: "power1.inOut",
                        rotateX: 0,
                        scrollTrigger: {
                            id: `${this.scrollTriggerIdGetMayaa(e)}_${a + 1}`,
                            trigger: i,
                            start: s,
                            end: "bottom bottom",
                            scrub: 1.5,
                            invalidateOnRefresh: !0,
                            onUpdate: (e) => {
                                if (0 === e.progress && a > 0)
                                    for (let e = o.length - 1; e >= a - 1; e--)
                                        o[e].classList.remove("collection-inactive"), o[e].classList.add("active");
                            },
                            onEnter: () => {
                                i.classList.add("active"),
                                    o.forEach((e) => {
                                        e !== i && e.classList.remove("active");
                                    });
                            },
                        },
                        onStart: () => {
                            if (a > 0) for (let e = 0; e < a; e++) o[e].classList.add("collection-inactive");
                        },
                    });
                let r = null;
                null != i.querySelector("img")
                    ? (r = i.querySelector("img"))
                    : null != i.querySelector("svg") && (r = i.querySelector("svg")),
                    null != r &&
                        (r.addEventListener("mouseenter", () => {
                            i.classList.add("media-hover");
                        }),
                        r.addEventListener("mouseleave", () => {
                            i.classList.remove("media-hover");
                        })),
                    i.addEventListener("click", function (e) {
                        const o = t.getChildren()[a];
                        if (o.scrollTrigger) {
                            let e = 0;
                            (e = a > 0 ? o.scrollTrigger.start + 2 : o.scrollTrigger.start + i.offsetHeight / 2),
                                window.scrollTo({ top: e, behavior: "smooth", ease: "power2.out" });
                        }
                    });
            });
        }
        this.focusTabSectionsCase(e);
    }
    scrollingMediaCards(e) {
        if (this.getBlockSizeMayaa(e) > 1) {
            const t = e.querySelectorAll("[scrolling-media-item]"),
                o = e.querySelector("[scrolling-media-heading]"),
                s = e.querySelector("[scrolling-media-wrapper]"),
                i = e.querySelector("[scrolling-media-description]"),
                a = s.offsetHeight / 4;
            gsap.set(t[1], { y: a }),
                t[2] && gsap.set(t[2], { y: 2 * a }),
                null != o && gsap.set(o, { scale: 0, opacity: 0 }),
                null != i && gsap.set(i, { scale: 0, opacity: 0 });
            const r = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top+=10% bottom",
                    end: "bottom top",
                    scrub: 1.5,
                    pin: !1,
                    invalidateOnRefresh: !0,
                },
            });
            r.to(s, {
                y: -a,
                onStart: () => {
                    null != o && gsap.to(o, { scale: 1, opacity: 1, duration: 1.5, ease: "power4.out" }),
                        null != i && gsap.to(i, { scale: 1, opacity: 1, duration: 1.5, ease: "power4.out" });
                },
                onReverseComplete: () => {
                    null != o && gsap.set(o, { scale: 0, opacity: 0 }),
                        null != i && gsap.set(i, { scale: 0, opacity: 0 });
                },
            }),
                r.to(t[0], { y: a }, "<"),
                r.to(t[1], { y: 0 }, "<"),
                t[2] && r.to(t[2], { y: -a }, "<");
        }
    }
    mediaWithCards(e) {
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelector("[media-wrap-video]"),
            s = e.querySelector("[media-wrap-video-content]"),
            i = e.querySelector("[minicard-media-wrap]"),
            a = gsap.getProperty(s, "--media-content-spacing") / 2,
            r = gsap.getProperty(s, "--media-clip-spacing-top"),
            n = gsap.getProperty(s, "--media-clip-spacing-bottom");
        gsap.set(o, { "--media-clip-spacing-top": `${r}px`, "--media-clip-spacing-bottom": `${n}px` }),
            null != i && gsap.set(i, { y: this.viewportHeight });
        const l = gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: "top top+=" + (t ? 0 : this.headerHeight),
                end: "+=100%",
                scrub: 1.5,
                pin: !0,
                invalidateOnRefresh: !0,
            },
        });
        l
            .to(o, {
                "--media-clip-spacing": "0px",
                "--card-radius": "0px",
                "--media-clip-spacing-top": "0px",
                "--media-clip-spacing-bottom": "0px",
            })
            .to(s, { "--media-content-spacing": `${a}px` }, "<"),
            null != i && l.to(i, { y: 0 }, "<50%"),
            this.focusTabSectionsCase(e);
    }
    imageWithTextCarousel(e) {
        if (this.getBlockSizeMayaa(e) > 1) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.querySelectorAll("[multi-media-item]"),
                s = e.querySelectorAll("[multi-media-item-content]"),
                i = e.querySelectorAll("[multi-media-item-image]"),
                a = e.querySelectorAll("[multi-media-pagination]"),
                r = s.length - 1,
                n = (Math.min(window.innerHeight, 1e3), 4 * (s.length - 1)),
                l = 4 * (s.length - 1),
                c = n / (s.length - 1),
                d = l / (s.length - 1);
            gsap.set(o, { opacity: 0, yPercent: 100 }),
                gsap.set(a, { opacity: 0.2 }),
                gsap.set(a[0], { opacity: 1 }),
                gsap.set(i, { xPercent: n }),
                gsap.set(o[0], { yPercent: 0 });
            gsap.timeline({
                scrollTrigger: {
                    id: `${this.scrollTriggerIdGetMayaa(e)}_0`,
                    trigger: o[0],
                    start: "top 100%",
                    end: "bottom+=20% bottom",
                    scrub: 1.5,
                    invalidateOnRefresh: !0,
                },
            })
                .to(o[0], { opacity: 1 })
                .to(i[0], { xPercent: 0 }, "<")
                .to(a[0], { opacity: 1 }, "<");
            const g = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: 100 * r + "%",
                    scrub: 1.5,
                    pin: !0,
                    invalidateOnRefresh: !0,
                },
            });
            o.forEach((e, t) => {
                t > 0 &&
                    g
                        .to(e, { yPercent: 0, opacity: 1 })
                        .to(s[t - 1], { opacity: 0, yPercent: -100 }, "<")
                        .to(i[t], { xPercent: c * t, yPercent: d * t }, "<")
                        .to(i[t - 1], { xPercent: t - 1 == 0 ? 0 : c, yPercent: t - 1 == 0 ? 0 : d }, "<")
                        .to(a[t], { opacity: 1 }, "<")
                        .to(a[t - 1], { opacity: 0.2 }, "<")
                        .to(a[0], { opacity: 0.2 }, "<");
            }),
                this.focusTabSectionsCase(e);
        }
    }
    trendingProduct(e) {
        const t = e.getAttribute("data-animation-type"),
            o = e.querySelectorAll("[card-item-main]"),
            s = e.querySelector("[card-item-center-area]"),
            i = e.querySelector("[card-item-header]"),
            a = e.querySelector("[card-item-header-content]"),
            r = e.querySelector("[card-title-front]"),
            n = e.querySelector("[card-title-back]");
        let l,
            c = 0;
        const d = o[0].offsetWidth,
            g = window.innerWidth / 2,
            p = s.offsetWidth / 2;
        if (
            (gsap.set(o, { opacity: 0, scale: 0.5, rotationY: 70 }),
            "style-2" != t && gsap.set([r, n], { x: (e) => (0 == e ? -2 : 2) }),
            o.forEach((e, t) => {
                const o = 10 * t,
                    s = e.getBoundingClientRect(),
                    i = p - s.x + s.width;
                gsap.set(e, { x: i, z: `${o}px` });
            }),
            gsap.set(o, { transformStyle: "preserve-3d", perspective: 1e3 }),
            gsap.set(s, { transformStyle: "preserve-3d", perspective: 1e3 }),
            "style-2" == t)
        )
            (l = 0.8), (c = 10), gsap.set(i, { y: d / 2 });
        else {
            (l = 0.55), (c = 35);
            const e = a.textContent || a.innerText,
                t = (function (e, t) {
                    let o = [];
                    for (let s = 0; s < e.length; s += t) o.push(e.slice(s, s + t));
                    return o;
                })(e, Math.ceil(e.length / 2));
            (r.innerText = t[0]), (n.innerText = t[1]);
        }
        const u = gsap.timeline({
            scrollTrigger: {
                id: this.scrollTriggerIdGetMayaa(e),
                trigger: e.closest(".section-wrapper"),
                start: () => "top top+=" + window.innerHeight * l,
                end: `bottom bottom-=${c}%`,
                scrub: 1.5,
                invalidateOnRefresh: !0,
            },
        });
        "style-2" == t ? u.to(i, { y: 0 }) : u.to([r, n], { x: (e) => (0 == e ? -g : g), opacity: 0 }),
            u.to(o, { x: 0, rotationY: 0, scale: 1, opacity: 1, z: 0 }, "<"),
            this.focusTabSectionsCase(e);
    }
    mainProductSpecification(e) {
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelectorAll("[product-highlight-section]"),
            s = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e.closest(".section-wrapper"),
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: `+=${75 * o.length}%`,
                    scrub: 1.5,
                    pin: !0,
                    invalidateOnRefresh: !0,
                },
            });
        // o.forEach((e, t) => {
        //     const i = e.querySelector("[highlight-left-box]"),
        //         a = e.querySelector("[highlight-right-box]"),
        //         r = e.querySelector("[highlight-center-box]"),
        //         n = e.querySelector("[highlight-left-bar]"),
        //         l = e.querySelector("[highlight-right-bar]"),
        //         bottombar = e.querySelector("[highlight-bottom-bar]"),
                
        //         c = r.getBoundingClientRect().width;
        //     gsap.set(o, { "--pointer-line-size": `${c}px` }),
        //         gsap.set(n, { "--media-line-width": "0%" }),
        //         gsap.set(l, { "--info-line-width": "0%" }),
        //         gsap.set([i, a], { opacity: 0 }),
        //         gsap.set(i, { scale: 0 }),
        //         s
        //             .to(l, { "--info-line-width": "100%" })
        //             .to(n, { "--media-line-width": "100%" }, "<")
        //             .to(
        //                 i,
        //                 {
        //                     x: 0,
        //                     scale: 1,
        //                     opacity: 1,
        //                     onComplete: () => {
        //                         t < o.length - 1 &&
        //                             (o[t].classList.remove("active"),
        //                             o[t].classList.add("in-active"),
        //                             o[t + 1].classList.remove("in-active"),
        //                             o[t + 1].classList.add("active"));
        //                     },
        //                     onReverseComplete: () => {
        //                         t > 0 &&
        //                             (o[t].classList.remove("active"),
        //                             o[t].classList.add("in-active"),
        //                             o[t - 1].classList.remove("in-active"),
        //                             o[t - 1].classList.add("active"));
        //                     },
        //                 },
        //                 "<"
        //             )
        //             .to(a, { opacity: 1 }, "<+=35%");
        // });
        o.forEach((e, t) => {
    const i = e.querySelector("[highlight-left-box]"),
        a = e.querySelector("[highlight-right-box]"),
        r = e.querySelector("[highlight-center-box]"),
        n = e.querySelector("[highlight-left-bar]"),
        l = e.querySelector("[highlight-right-bar]"),
        bottombar = e.querySelector("[highlight-bottom-bar]"),
        bottombox = e.querySelector("[highlight-bottom-box]"),

        c = r.getBoundingClientRect().width;

    gsap.set(o, { "--pointer-line-size": `${c}px` });
    gsap.set(n, { "--media-line-width": "0%" });
    gsap.set(l, { "--info-line-width": "0%" });
    gsap.set(bottombar, { "--bottom-line-width": "0%" });

    gsap.set([i, a, bottombox], { opacity: 0 }); 
    gsap.set(i, { scale: 0 });
    gsap.set(bottombox, { y: 20 });

    s
        .to(l, { "--info-line-width": "100%" })
        .to(n, { "--media-line-width": "80%" }, "<")
        .to(bottombar, { "--bottom-line-width": "35%" }, "<")

        .to(
            i,
            {
                scale: 1,
                opacity: 1,
            },
            "<"
        )

        // 👇 bottom content fade-in
        .to(
            bottombox,
            {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: "power2.out",
            },
            "<+=0.2"
        )

        .to(a, { opacity: 1 }, "<+=0.1");
});
   
    }
    highlightTextWithImage(e) {
        let t = gsap.matchMedia();
        const o = e.querySelector("[highlight-text-content]"),
            s = gsap.getProperty(o, "--sentence-media-width"),
            i = new SplitText(o, { type: "words", wordsClass: "media-sentence-words" });
        t.add("(max-width: 767px)", () => {
            i && i.revert();
        });
        const a = e.querySelectorAll(".media-sentence-words"),
            r = o.getBoundingClientRect().width;
        let n = document.createElement("div");
        n.classList.add("media-sentence-lines"), o.appendChild(n);
        let l = 0;
        a.forEach((e, t) => {
            let i = "text-based",
                a = e.innerHTML,
                c = !1;
            e.classList.contains("sentence-media") ? ((i = "sentence-media"), (c = !0)) : (a = a.trim());
            let d = e.offsetWidth;
            (d = 0 == d ? s : e.offsetWidth + 55),
                (l += d),
                l > r &&
                    ((l = 0 + d),
                    (n = document.createElement("div")),
                    n.classList.add("media-sentence-lines"),
                    o.appendChild(n));
            const g = document.createElement("span");
            g.classList.add(i), c && g.classList.add("media-wrapper"), (g.innerHTML = a), n.appendChild(g);
        }),
            a.forEach((e) => e.remove());
        const c = e.querySelectorAll(".media-sentence-lines"),
            d = gsap.timeline({});
        let g = "top 85%";
        c.forEach((t, o) => {
            t.setAttribute("data-line-count", o + 1),
                o > 0 && (g = "top 60%"),
                d.to(t, {
                    scrollTrigger: {
                        id: `${this.scrollTriggerIdGetMayaa(e)}_${o + 1}`,
                        trigger: t,
                        start: g,
                        end: "bottom bottom",
                        scrub: 1.5,
                        invalidateOnRefresh: !0,
                        onEnter: () => {
                            t.classList.add("active");
                        },
                        onLeaveBack: () => {
                            t.classList.remove("active");
                        },
                    },
                });
        }),
            this.focusTabSectionsCase(e);
    }
    mixAndMatchBundle(e) {
        if ("none" == this.getSectionAnimationStyle(e)) return !1;
        const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            ),
            o = e.querySelector("[bundle-product-wrapper-masonry]"),
            s = o.querySelectorAll(".even-masonry"),
            i = o.querySelectorAll(".odd-masonry"),
            a = e.querySelector("[bundle-product-wrapper]"),
            r = e.querySelectorAll("[bundle-product-item]"),
            n = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e,
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: "+=150%",
                    scrub: 1.5,
                    toggleActions: "play none none reverse",
                    invalidateOnRefresh: !0,
                },
            }),
            l = o.clientHeight - r[0].clientHeight / 2;
        gsap.set(a, { height: l }),
            n
                .to(s, { yPercent: -10, y: -("" + r[0].clientHeight / 2), duration: 1.2, ease: "none" })
                .to(i, { yPercent: -10, y: -("" + r[0].clientHeight / 2), duration: 2, ease: "none" }, "<"),
            this.focusTabSectionsCase(e);
    }
    featuredCollectionsList(e) {
        if (this.getBlockSizeMayaa(e) > 0) {
            const t = this.firstSectionTransparentCase(
                e.getAttribute("data-section-index"),
                e.getAttribute("data-section")
            );
            let o = gsap.matchMedia();
            const s = e.querySelector("[feature-collection-list-img]"),
                i = e.querySelectorAll("[feature-collection-list-main-media]"),
                a = e.querySelector("[feature-collection-list-wrapper]"),
                r = e.querySelectorAll("[feature-collection-list-left-heading]"),
                n = e.querySelectorAll("[feature-collection-list-img-desc]"),
                l = e.querySelectorAll("[feature-collection-list-img-desc-inner]"),
                c = e.querySelectorAll("[feature-collection-list-multi-media-img]"),
                d = e.querySelector("[featured-collections-main-wrapper]"),
                g = e.querySelectorAll("[feature-collection-tab-child]"),
                p = e.querySelectorAll("[feature-list-tabs-content-sec]"),
                u = e.querySelectorAll("[feature-collection-text-inner-img]"),
                h = e.querySelectorAll("[feature-collection-list-empty-sec]"),
                y = e.querySelector("[feature-collection-list-front]"),
                m = e.querySelector("[feature-collection-list-tab]"),
                f = Array.from(m.children),
                b = m.offsetHeight;
            gsap.set(d, { "--list-tabs-height": `${b}px` });
            let v,
                S,
                w,
                x = 0,
                A = "";
            if ((M(g, p, r), n.length > 0)) {
                const E = (gsap.getProperty(n[0], "--text-box-height") / n[0].offsetWidth) * 100;
                gsap.set(n, { opacity: 0 }), gsap.set(l, { width: `${E}%` });
            }
            let q = Math.floor(g.length / 2);
            const L = r[q].querySelector("[feature-collection-heading-common]");
            u.length > 0 &&
                ((w = new SplitText(u, { type: "words,chars", charsClass: "featureDescParent" })),
                (A = new SplitText(u, { type: "chars" })),
                gsap.set(u, { opacity: 0 })),
                (S = new SplitText(L, { type: "words", wordsClass: "featureWordParent" })),
                (v = new SplitText(L, { type: "chars" })),
                o.add("(max-width: 767px)", () => {
                    v && v.revert(), S && S.revert(), w && w.revert(), A && A.revert();
                }),
                g[q].classList.add("active-tab"),
                p[q].classList.add("active"),
                r[q].classList.add("fade-in");
            const T = H(e.closest(".section-wrapper")),
                C = g[q].getAttribute("data-color-scheme");
            e.closest(".section-wrapper").classList.replace(T, C),
                gsap.set(h, { scaleX: 0 }),
                gsap.set(a, { opacity: 0 }),
                gsap.set(c, { scale: 0 }),
                gsap.set(s, { xPercent: -100, scale: 0.7 }),
                g.forEach((t, o) => {
                    t.addEventListener("click", function () {
                        if (!this.classList.contains("active-tab")) {
                            M(g, p, r);
                            const s = H(e.closest(".section-wrapper")),
                                i = this.getAttribute("data-color-scheme");
                            if (
                                (e.closest(".section-wrapper").classList.replace(s, i),
                                p[o].classList.add("active"),
                                r[o].classList.add("fade-in"),
                                1 === P.getChildren()[0].progress())
                            ) {
                                gsap.set(a, { opacity: 1 }), v && v.revert(), S && S.revert();
                                let e = r[o].querySelector("[feature-collection-heading-common]");
                                (S = new SplitText(e, { type: "words", wordsClass: "featureWordParent" })),
                                    (v = new SplitText(e, { type: "chars" })),
                                    A &&
                                        (w && w.revert(),
                                        A && A.revert(),
                                        gsap.from(A.chars, { opacity: 0, ease: "circ.out", stagger: 0.005 })),
                                    gsap.from(v.chars, {
                                        duration: 0.8,
                                        opacity: 0,
                                        stagger: 0.02,
                                        rotationX: 90,
                                        ease: "expo.out",
                                    });
                            }
                            for (; f.indexOf(t) !== Math.floor(g.length / 2); ) f.push(f.shift());
                            f.forEach((e) => m.appendChild(e)), I();
                        }
                    });
                });
            const P = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e,
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: "+=150%",
                    scrub: !0,
                    pin: !0,
                    invalidateOnRefresh: !0,
                    onUpdate: (e) => {
                        const t = P.getChildren()[0],
                            o = P.getChildren()[1],
                            s = P.getChildren()[2],
                            r = P.getChildren()[3],
                            g = t.progress(),
                            p = o.progress(),
                            h = s.progress(),
                            f = r.progress();
                        1 === e.direction
                            ? (g > 0 &&
                                  (m.classList.add("tabs-pos-top"),
                                  d.classList.add("tab-content-active"),
                                  y && null != y && y.classList.add("fade-out-text")),
                              p > 0.2 && n.length > 0 && gsap.set(l, { opacity: 1 }),
                              n.length > 0
                                  ? f > 0 &&
                                    (gsap.to(i, { scale: 0, duration: 0.15, ease: "sine.outIn" }),
                                    gsap.to(c, { scale: 1, duration: 0.18, ease: "sine.inOut" }))
                                  : h > 0.5 &&
                                    (gsap.to(i, { scale: 0, duration: 0.15, ease: "sine.outIn" }),
                                    gsap.to(c, { scale: 1, duration: 0.18, ease: "sine.inOut" })))
                            : (g < 0.1 &&
                                  (m.classList.remove("tabs-pos-top"),
                                  gsap.to(m, {
                                      ease: "Power2.easeIn",
                                      onComplete: () => {
                                          d.classList.remove("tab-content-active"),
                                              y && null != y && y.classList.remove("fade-out-text");
                                      },
                                  })),
                              p < 0.9 && gsap.set(u, { opacity: 0 }),
                              p < 0.2 && (n.length > 0 && gsap.set(l, { opacity: 0 }), gsap.set(a, { opacity: 0 })),
                              h < 0.9 &&
                                  (gsap.to(i, { scale: 1, duration: 0.15, ease: "sine.outIn" }),
                                  gsap.to(c, { scale: 0, duration: 0.18, ease: "sine.inOut" })));
                    },
                },
            });
            function M(e, t, o) {
                e.forEach((e, s) => {
                    e.classList.remove("active-tab"), t[s].classList.remove("active"), o[s].classList.remove("fade-in");
                });
            }
            function I() {
                const t = e.querySelectorAll("[feature-collection-tab-child]"),
                    o = Math.floor(g.length / 2);
                g.forEach((e, s) => {
                    const i = s - o;
                    let a = 10 - Math.abs(i);
                    gsap.set(e, { zIndex: a }),
                        gsap.to(e, {
                            x: i * x,
                            duration: 0.3,
                            ease: "power2.out",
                            onCompleteAll: () => {
                                t[o].classList.add("active-tab");
                            },
                        });
                });
            }
            function H(e) {
                return Array.from(e.classList).find((e) => e.startsWith("scheme-")) || null;
            }
            P.to(s, {
                xPercent: 0,
                scale: 1,
                onStart: () => {
                    m.classList.add("tabs-pos-top"),
                        d.classList.add("tab-content-active"),
                        y && null != y && y.classList.add("fade-out-text");
                },
                onComplete: () => {
                    n.length > 0 && gsap.set(n, { opacity: 1 }),
                        gsap.set(a, { opacity: 1 }),
                        gsap.from(v.chars, {
                            duration: 0.8,
                            opacity: 0,
                            stagger: 0.02,
                            rotationX: 90,
                            ease: "expo.out",
                        });
                },
            }),
                n.length > 0
                    ? P.to(l, {
                          width: "100%",
                          onComplete: () => {
                              gsap.set(u, { opacity: 1 }),
                                  gsap.from(A.chars, { opacity: 0, ease: "circ.out", stagger: 0.004 });
                          },
                      })
                          .to(h, { scaleX: 1 })
                          .to(h, { scaleX: 0 })
                    : P.to(h, {
                          scaleX: 1,
                          onComplete: () => {
                              gsap.set(u, { opacity: 1 }),
                                  gsap.from(A.chars, { opacity: 0, ease: "circ.out", stagger: 0.004 });
                          },
                      }).to(h, { scaleX: 0 }),
                P.add(() => {}, "+=0.10"),
                this.focusTabSectionsCase(e);
        }
    }
    scrollSlidesBanner(e) {
        if (this.getBlockSizeMayaa(e) > 1) {
            const t = this.firstSectionTransparentCase(
                    e.getAttribute("data-section-index"),
                    e.getAttribute("data-section")
                ),
                o = e.querySelectorAll("[scroll-slide-item]"),
                s = e.querySelectorAll("[scroll-slide-progress]"),
                i = this.scrollTriggerIdGetMayaa(e),
                a = o.length - 1,
                r = Math.min(window.innerHeight, 1e3);
            gsap.set(o, { yPercent: 100 }), gsap.set(o[0], { yPercent: 0 }), o[0].classList.add("is-current");
            const n = gsap.timeline({
                scrollTrigger: {
                    id: this.scrollTriggerIdGetMayaa(e),
                    trigger: e,
                    start: "top top+=" + (t ? 0 : this.headerHeight),
                    end: "+=" + r * a,
                    scrub: !0,
                    pin: !0,
                    toggleActions: "play none reverse none",
                    invalidateOnRefresh: !0,
                    onEnter: () => {
                        e.classList.add("section-banner-pinned");
                    },
                    onLeaveBack: () => {
                        e.classList.remove("section-banner-pinned");
                    },
                },
            });
            function l(e) {
                for (let e = 0; e < s.length - 1; e++)
                    s[e].classList.remove("active"), o[e].classList.remove("is-current");
                s[e].classList.add("active"),
                    o[e].classList.add("is-current"),
                    0 == e && (s[e].classList.add("active"), o[e].classList.add("is-current"));
            }
            function c(e) {
                s[e].classList.contains("active") &&
                    (s[e].classList.remove("active"),
                    o[e].classList.remove("is-current"),
                    e > 0 && (s[e - 1].classList.add("active"), o[e - 1].classList.add("is-current")),
                    0 == e && (s[e].classList.add("active"), o[e].classList.add("is-current")));
            }
            o.forEach((e, t) => {
                const r = s[t].querySelector("[scroll-slide-circle]");
                n.fromTo(
                    r,
                    { "--scroll-slide-circle-progress": 1 },
                    {
                        "--scroll-slide-circle-progress": 0,
                        ease: "power2.out",
                        onStart: () => {
                            0 == t && (s[t].classList.add("active"), o[t].classList.add("is-current"));
                        },
                        onComplete: () => {
                            o[t + 1] && (gsap.to(o[t + 1], { yPercent: 0 }), l(t + 1));
                        },
                        onReverseComplete: () => {
                            t > 0 && gsap.to(o[t], { yPercent: 100 }), c(t);
                        },
                    }
                ),
                    s[t].addEventListener("click", (e) => {
                        l(t);
                        const o = ScrollTrigger.getById(i),
                            s = (o.end - o.start) / a;
                        let r = o.start + s * t + 100;
                        0 == t && (r = o.start),
                            t == a && (r = o.end),
                            gsap.to(window, { scrollTo: r, duration: 0.5, ease: "power2.inOut" });
                    });
            }),
                this.focusTabSectionsCase(e);
        }
    }
    lenisIntializationData() {
        gsap.matchMedia().add("(min-width: 768px)", () => {
            const e = new Lenis({
                duration: 1.5,
                easing: (e) => 1 - Math.pow(1 - e, 3),
                smooth: !0,
                sync: !0,
                smoothTouch: !1,
                infinite: !1,
                syncTouch: !0,
                autoResize: !0,
            });
            (window.lenis = e),
                ScrollTrigger.defaults({ pinType: "transform", overwrite: "auto", anticipatePin: 1, pin: !1 }),
                ScrollTrigger.config({ autoRefreshEvents: "DOMContentLoaded,load,resize", ignoreMobileResize: !0 }),
                requestAnimationFrame(function t(o) {
                    e.raf(o), ScrollTrigger.update(), requestAnimationFrame(t);
                });
        });
    }
    lenisDestroyData() {
        window.lenis && "function" == typeof window.lenis.raf && lenis.destroy();
    }
    scrollTriggerIdGetMayaa(e) {
        return e.getAttribute("data-section");
    }
    getBlockSizeMayaa(e) {
        return parseInt(e.getAttribute("data-block-size"));
    }
    getSectionAnimationStyle(e) {
        return e.getAttribute("data-animation-style");
    }
    getHeaderHeight() {
        return this.headerHeight;
    }
    getPixelToVw(e) {
        const t = (e / this.viewportWidth) * 100;
        return parseFloat(t.toFixed(2));
    }
    firstSectionTransparentCase(e, t) {
        if ("true" == this.transparentHeader) {
            if (Shopify.designMode) {
                const e = `shopify-section-${t}`,
                    o = document.getElementById("MainContent").querySelectorAll("section"),
                    s = document.getElementById(e);
                return 0 == Array.from(o).indexOf(s);
            }
            return "1" == e;
        }
        return !1;
    }
    focusTabSectionsCase(e) {
        let t = 0,
            o = 0,
            s = !1;
        window.addEventListener("keydown", (e) => {
            s = e.shiftKey && "Tab" === e.key;
        }),
            e.addEventListener("focusin", (i) => {
                const a = e.getAttribute("data-section"),
                    r = e.getAttribute("methodcalled");
                if (this.lastFocusedSectionTab !== a)
                    if (
                        ((this.lastFocusedSectionTab = a),
                        "scrollableCollectionList" == r ||
                            "trendingProduct" == r ||
                            "mixAndMatchBundle" == r ||
                            "highlightTextWithImage" == r)
                    ) {
                        if ("scrollableCollectionList" == r) {
                            const t = e.getAttribute("data-block-size"),
                                o = i.target.parentElement
                                    .closest("[collection-name-text]")
                                    .getAttribute("sclist-block-index");
                            if ("v2" == e.getAttribute("data-animation-style")) {
                                const e = ScrollTrigger.getById(a),
                                    s = e.end,
                                    i = e.start;
                                let r = i + ((s - i) / (t - 1)) * (o - 1);
                                1 == o && (r = i), gsap.to(window, { scrollTo: r, ease: "none" });
                            } else {
                                const e = `${a}_${o}`,
                                    t = ScrollTrigger.getById(e);
                                o > 1 && gsap.to(window, { scrollTo: t.start, ease: "none" });
                            }
                        } else if ("trendingProduct" == r) {
                            const e = ScrollTrigger.getById(a);
                            gsap.to(window, { scrollTo: e.end, ease: "none" });
                        } else if ("mixAndMatchBundle" == r) {
                            const e = ScrollTrigger.getById(a);
                            i.target.parentElement.closest("[bundle-product-item]").previousElementSibling ||
                                gsap.to(window, { scrollTo: e.start, ease: "none" });
                        } else if ("highlightTextWithImage" == r) {
                            const e = i.target.parentElement
                                    .closest("[data-hightlight-item]")
                                    .parentElement.closest("[data-line-count]")
                                    .getAttribute("data-line-count"),
                                t = `${a}_${e}`,
                                o = ScrollTrigger.getById(t);
                            e > 1 && gsap.to(window, { scrollTo: o.start, ease: "none" });
                        }
                    } else {
                        const n = ScrollTrigger.getById(a),
                            l = n.end,
                            c = n.start;
                        let d = 0;
                        if ("productsGrid" == r) {
                            const e = i.target.parentElement;
                            if (e.classList.contains("two-rows")) {
                                (o = 0), (t += 1), (d = l + gsap.getProperty(e, "top") * t);
                            } else if (e.classList.contains("three-rows")) {
                                t = 0;
                                let i = gsap.getProperty(e, "marginTop") + 25;
                                if (s) {
                                    (o += 1), (d = l + i * (3 - o));
                                } else {
                                    let e = i * o;
                                    (o += 1), (d = l + e);
                                }
                            }
                            gsap.to(window, { scrollTo: d, ease: "none" });
                        } else if ("imageWithTextCarousel" == r) {
                            const t = e.getAttribute("data-block-size"),
                                o = i.target.parentElement
                                    .closest("[multi-media-item]")
                                    .getAttribute("scrollable-block-imwt"),
                                s = l - c;
                            let a = c + (s / t) * (o - 1) + (s * (4 * (t - 1))) / 100;
                            1 == o ? (a = c) : o == t && (a = l), gsap.to(window, { scrollTo: a, ease: "none" });
                        } else if ("verticalCarousel" == r) {
                            const t = e.getAttribute("data-block-size"),
                                o = i.target.parentElement
                                    .closest("[vertical-circle-content]")
                                    .getAttribute("vc-block-content-index");
                            let s = c + ((l - c) / t) * o - 50 * o;
                            t == o && (s = l), gsap.to(window, { scrollTo: s, ease: "none" });
                        } else if ("bannerSlider" == r) {
                            if (null != i.target.parentElement.closest("[banner-slider-overlay-content]")) {
                                let e = l;
                                gsap.to(window, { scrollTo: e, ease: "none" });
                            } else s && gsap.to(window, { scrollTo: c, ease: "none" });
                        } else if ("scrollSlidesBanner" == r) {
                            e.getAttribute("data-block-size");
                            const t = e.querySelectorAll("[scroll-slide-progress]"),
                                o = i.target.parentElement.closest("[scroll-slide-item]");
                            if (null != o) {
                                o.getAttribute("data-count");
                                t[parseInt(o.getAttribute("data-count"), 10) - 1].click();
                            }
                        } else gsap.to(window, { scrollTo: l, ease: "none" });
                    }
            }),
            e.addEventListener("focusout", (t) => {
                e.contains(document.activeElement) || (this.lastFocusedSectionTab = null);
            });
    }
}
